import { Button, Flex, Typography } from '@iheartjane/reefer';

import { useKioskSpacing } from '@jane/kiosk/hooks';

import { Modal } from '../Modal';

export const CartCheckoutError = ({
  detail,
  error,
  onClose,
}: {
  detail?: string;
  error?: string;
  onClose: () => void;
}) => {
  const { defaultSpacing, getKioskSpacing, isIpad } = useKioskSpacing();

  const getErrorMessage = () => {
    // Check if this is an Aeropay error.
    // Aeropay (JanePay) errors start with "AP" followed by 3-4 numbers
    const aeropayRegex = /^Error (AP\d{3,4}): (.+)$/;
    const aeropayError = String(error).match(aeropayRegex);

    if (aeropayError) {
      switch (aeropayError[1]) {
        case 'AP300':
          return 'We are having issues connecting to your bank. Please select another bank account or payment method and reach out to support@iheartjane.com to resolve the issue.';

        case 'AP301':
          return 'Your account has been blocked, please select another payment method and reach out to support@iheartjane.com to resolve the issue.';

        case 'AP302':
        case 'AP306':
        case 'AP307':
        case 'AP315':
          return 'We could not approve your payment, your available balance might be insufficient for this transaction. Please select another bank account or payment method and reach out to support@iheartjane.com to resolve the issue.';

        case 'AP304':
          return 'Your transaction amount exceeds the daily limit on your account. Please try a smaller purchase or another payment method and reach out to support@iheartjane.com to resolve the issue.';

        case 'AP305':
          return "We've detected delinquent activity on your account, please select another bank account or payment method and reach out to support@iheartjane.com to resolve the issue.";

        case 'AP310':
          return "We're sorry, your transaction has been declined, please select another bank account or payment method and reach out to support@iheartjane.com to resolve the issue.";

        default:
          return 'Please try again or select another payment method and reach out to support@iheartjane.com to resolve the issue.';
      }
    } else {
      return 'Please try again.';
    }
  };

  return (
    <Modal
      appId="root"
      contentLabel="Bag Alert"
      onRequestClose={onClose}
      open
      overlayClose
      variant="dialogue"
    >
      <Modal.Content>
        <Flex flexDirection="column">
          <Typography variant="h2-semibold" mb={getKioskSpacing(24, 8)}>
            Something went wrong
          </Typography>

          <Typography mb={defaultSpacing}>
            {detail ?? getErrorMessage()}
          </Typography>
          <Button
            label="OK"
            onClick={onClose}
            full
            branded
            size={isIpad ? 'small' : 'default'}
          />
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
